<!--
 * @Author: Alfred
 * @Date: 2021-12-20 11:08:35
 * @LastAuthor: Alfred
 * @LastTime: 2023-05-11 16:04:08
 * @Description: 
-->
<template>
  <div class="channel-details">
    <div class="table-header">
      <span>渠道来源：{{ dataInfo.channel_name }}-{{
        dataInfo.channel_sub_name
      }}</span>
      <span>创建人：{{ dataInfo.editor_name }}</span>
      <span>录入时间：{{ dataInfo.create_time }}</span>
      <span v-if="dataInfo.recommender_name">推荐学员姓名：{{ dataInfo.recommender_name }}</span>
      <span v-if="dataInfo.extra">家长备注信息：{{ dataInfo.extra.remark }}</span>
    </div>
    <div class="table-body">
      <el-table
        :data="itemList"
        border
        stripe
        :header-cell-style="{
          background: '#4c84ff',
          color: '#fff',
          height: '60px',
          textAlign: 'center'
        }"
      >
        <el-table-column prop="create_time" label="联系时间" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time.substr(0, 11) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="editor_name"
          label="记录人"
          align="center"
        />
        <el-table-column
          prop="contact_type_name"
          label="联系类型"
          align="center"
        />
        <el-table-column
          prop="content"
          label="联系内容"
          align="center"
        />
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChannelDetails',
  components: {},
  data() {
    return {
      itemList: [],
      dataInfo: {}
    }
  },
  computed: {},
  watch: {},
  mounted() {
    const child_id = this.$route.query.child_id
    this.getInfoChannel(child_id)
  },
  methods: {
    async getInfoChannel(child_id) {
      const ret = await this.$http.getInfoChannel({ child_id })
      if (ret.code == 200) {
        this.dataInfo = ret.data.lead_info
        this.itemList = ret.data.list
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.channel-details {
  .table-header {
    padding: 40px 0;
    font-size: 14px;
    color: $color_black;
    span {
      margin-right: 60px;
    }
  }
}
</style>
